import {PayrollsList, PayrollShow}  from './Payrolls';

export default {
    list: PayrollsList,
    show: PayrollShow
};
